<template>
  <v-switch
    :label="'Sick'"
    v-model="switch1" color="green" @change="updateSickValue"
  ></v-switch>           
</template>
<script>
import CreateActivityMutation from '../mutations/CreateActivityMutation';
import DeleteActivityMutation from '../mutations/DeleteActivityMutation';
import GetActivityByUserQuery from '../queries/GetActivityByUserQuery';


function getSickValue( that, callback){
         
          that.$localStorage.currentDateSick='';
          that.$localStorage.sickMarkerValue=false;
          that.$apollo.query({ 
                variables: {
                    actDate: localStorage.currentDate,
                    username: localStorage.subID,         
                },
                query: GetActivityByUserQuery})
            .then(function logData(data) {
                  if(data.data.getActivityByUser.items !== null){
                    data.data.getActivityByUser.items.forEach(function(item){
                          //check for Sick
                          if(item.activityType=='Sick'){
                              that.$localStorage.currentDateSick=item.id;
                              that.$localStorage.sickMarkerValue='true';
                          }
                    });
                  }
                callback(that.$localStorage.sickMarkerValue);
            }).catch(console.error);
}


export default {
	data () {
		return {
      switch1: (localStorage.sickMarkerValue=='true'),
      GetActivityByUserQuery: GetActivityByUserQuery,
      DeleteActivityMutation: DeleteActivityMutation,
		}
	},
	components: {

  },
  methods: {
      updateSickValue(selectedItem){  
        
        if(selectedItem==true){
            //gather inputs
            var avaInput = {
                    id: localStorage.subID+'--'+( new Date().getTime() ),
                    username:  localStorage.subID,  
                    actDate: localStorage.currentDate,
                    activityType: 'Sick',
                    timestamp: ( new Date().getTime() ),
                    value: '0',
                    intensity: 'Sick',   
            } 

            
            //add to dynamodb
            this.$apollo.mutate({
                variables: {
                    input: avaInput
                },
                mutation: CreateActivityMutation
            }).then(function(data) {
                localStorage.currentDateSick=data.data.createActivity.id;
                localStorage.sickMarkerValue=selectedItem;
            }).catch(error => console.error(error));
                      

        }
        else{
          //we need to delete the sick value for this day
          //use localStorage.currentDateSick, value to remove the sick for the current day
            this.$apollo.mutate({ 
                variables: {
                  input:{
                    id: localStorage.currentDateSick,  
                  } 
                },
                mutation: DeleteActivityMutation})
            .then(function logData() {
                selectedItem='false';
                localStorage.sickMarkerValue=selectedItem;
                localStorage.currentDateSick='';
            }).catch(console.error);
            
        }
 
      },
  },
  beforeDestroy(){
    var that=this;
    that.$root.$off('DateChange');
  },
  mounted(){
    var that=this;

      getSickValue(that, function(){
            that.switch1=(localStorage.sickMarkerValue=='true');
      }); 

      that.$root.$on('DateChange', function getSick() {
          getSickValue(that, function(){
            that.switch1=(localStorage.sickMarkerValue=='true');
          }); 
      });
      
  
    
  },
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/home/Sick.vue